import { render, staticRenderFns } from "./service_flove.vue?vue&type=template&id=4b00e204&scoped=true&"
import script from "./service_flove.vue?vue&type=script&lang=js&"
export * from "./service_flove.vue?vue&type=script&lang=js&"
import style0 from "./service_flove.vue?vue&type=style&index=0&id=4b00e204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b00e204",
  null
  
)

export default component.exports